import clsx from 'clsx';
import {
  element,
  oneOf,
  oneOfType,
  string,
} from 'prop-types';

import { ALIGNS } from './constants';
import useStyles from './styles';

function Divider({ align, children }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {align !== ALIGNS.LEFT && <div className={classes.border} />}
      {children && (
        <span
          children={children}
          className={clsx(
            classes.content,
            classes[align],
          )}
        />
      )}
      {align !== ALIGNS.RIGHT && <div className={classes.border} />}
    </div>
  );
};

Divider.defaultProps = {
  align: ALIGNS.LEFT,
};

Divider.propTypes = {
  align: oneOf(Object.values(ALIGNS)),
  children: oneOfType([
    element,
    string,
  ]),
};

export default Divider;
